import { formatMoney } from '@archetype-themes/scripts/helpers/currency'

console.log('calculator.js!')

let productWeight = 0;

document.addEventListener("DOMContentLoaded", function() {
  const selectInput = document.querySelector('.input-options__select select');
  const inputDivs = document.querySelectorAll('.input-options > div');
  
  inputDivs.forEach(div => {
   const totalCount = inputDivs.length;
   const inputOption = div.querySelectorAll('input');
   const selectOption = div.querySelector('select');
   
   if (inputOption.length > 0) {
    inputOption.forEach(option => {
      option.addEventListener('input', event => {
        fillValues();
      })
    })
  }

   if (selectOption != null) {
     selectOption.addEventListener('change', event => {
       const selectedOption = event.target.options[event.target.selectedIndex];
       fillValues();
     })
   }

   fillValues();

   document.querySelectorAll(".product__quantity quantity-selector").forEach((element) => {
    element.addEventListener("click", fillValues);
  });
 }) 

 function fillValues() {
   let values = [];
   const inputDivs = document.querySelectorAll('.input-options > div');
   const addCartForm = document.querySelector('.shopify-product-form');

   inputDivs.forEach(div => {
    const totalCount = inputDivs.length;
    const inputNumberOption = div.querySelector('input[type="number"]');
    const inputTextOption = div.querySelector('input[type="text"]');
    const inputFileOption = div.querySelector('input[type="file"]');
    const inputRadioOption = div.querySelector('input[type="radio"]:checked');
    const inputSelectOption = div.querySelector('select');
    const inputCheckboxOption = div.querySelectorAll('input[type="checkbox"]:checked');

    const optionContainer = div.closest('.input-options__number, .input-options__radio, .input-options__text, .input-options__file, .input-options__checkbox, .input-options__select');
    const optionContainerLabel = optionContainer.querySelector('.input-options__title-text')?.textContent.trim().toLowerCase();
    const optionType = div.getAttribute("data-name");
    // const optionContainerLabelSplitted = optionContainerLabel.split('(')[0].trim();

     
    if (inputNumberOption && inputNumberOption.value) {
       values[inputNumberOption.name] = parseFloat(inputNumberOption.value);
       addHiddenInput(addCartForm, optionContainerLabel, `${inputNumberOption.value}`, optionType);
    }

    if (inputTextOption && inputTextOption.value) {
      let calculationValue = inputTextOption.dataset.calculationValue;
      values[inputTextOption.name] = parseFloat(calculationValue);
      addHiddenInput(addCartForm, optionContainerLabel, inputTextOption.value, optionType);
    }

    if (inputFileOption && inputFileOption.value) {
      let calculationValue = inputFileOption.dataset.calculationValue;
      values[inputFileOption.name] = parseFloat(calculationValue);
      const fileName = inputFileOption.files[0].name;
      addHiddenInput(addCartForm, optionContainerLabel, fileName, optionType);
    }

    if (inputRadioOption && inputRadioOption.value) {
      values[inputRadioOption.name] = parseFloat(inputRadioOption.value);
      addHiddenInput(addCartForm, optionContainerLabel, inputRadioOption.parentElement.querySelector('label').textContent.trim(), optionType);
    }

    if (inputSelectOption && inputSelectOption.value) {
      values[inputSelectOption.name] = parseFloat(inputSelectOption.value);
      addHiddenInput(addCartForm, optionContainerLabel, inputSelectOption.options[inputSelectOption.selectedIndex].text, optionType);
    }

    let name = '';
    let value = 0;
    let checkboxValue = '';
    inputCheckboxOption.forEach(option => {
      if (option && option.value) {
        name = option.name;
        value += parseFloat(option.value);
        const label = document.querySelector(`label[for="${option.id}"]`);
        const labelText = label ? label.textContent.trim() : '';
        checkboxValue += labelText + ', ';
      }
    })

    if (checkboxValue) {
      checkboxValue = checkboxValue.slice(0, -2);
      addHiddenInput(addCartForm, optionContainerLabel, checkboxValue, optionType);
    }


    if (name) {
      values[name] = parseFloat(value);
    }

     if (inputSelectOption != null) {
     }
   }) 

   const price = calculatePrice(values, 1);
   productWeight = calculateWeight(values);
   console.log('current weight: ', productWeight)
   
   setPrice(price);
 }

 function addHiddenInput(form, name, value, optionType) {
    const existingInput = form.querySelector(`input[data-option-type="${optionType}"]`);

    if (existingInput) {
      existingInput.value = value;
      existingInput.name = `properties[${name}]`;
    } else {
      const hiddenInput = document.createElement('input');
      hiddenInput.type = 'hidden';
      hiddenInput.name = `properties[${name}]`;
      hiddenInput.value = value;
      hiddenInput.setAttribute('data-option-type', optionType);


      form.appendChild(hiddenInput);
    }
  }
    // const variantButtons = document.querySelectorAll('.variant__button-label');

    // if (variantButtons) {
    //     variantButtons.forEach(button => {
    //         button.onclick = function() {
    //             if (button.querySelector('input')) {
    //             button.querySelector('input').focus();
    //             button.querySelector('input').select();
    //             }
    //         };
    //     });
        
    //     let values = {};
    //     var valueElements = document.querySelectorAll('[data-calculator]');
    
    //     valueElements.forEach(element => {
    //         values[element.name] = element.value;

    //         element.onkeyup = function(el) {
    //             values[element.name] = parseFloat(element.value);
    //             let quantity = parseFloat(document.querySelector('input[name="quantity"]').value);
    //             let price = calculatePrice(values, quantity);
    //             console.log(price);
    //             setPrice(price);
    //         };
    //     });
    //     console.log(values);
    // }

    function setPrice(price) {
      const priceEls = document.querySelectorAll('.price-value');
      let quantity = parseFloat(document.querySelector('input[name="quantity"]').value);
      const blockPrice = document.querySelector("block-price");
      const ppiText = document.querySelector("block-price .customDef")?.getAttribute("data-stukprijs");
      const originalPrice = parseFloat(document.querySelector(".input-options").getAttribute("data-original-price")) / 100;
      const originalPriceFormatted = originalPrice.toFixed(2);

      if (quantity > 1 && blockPrice && price) {
          let span = blockPrice.querySelector("span.stukprijs");
      
          if (!span) {
              span = document.createElement("span");
              span.classList.add("stukprijs"); 
              blockPrice.appendChild(span);
          } 
          span.textContent = `${ppiText}: €${price.toFixed(2)}`; 
      } 

      if (quantity === 1) {
        const span = document.querySelector("span.stukprijs");
        if (span) {
            span.remove(); // Safely remove the span if it exists
        }
    }
    
      // const heightInput = document.querySelector('.input-options__number input');

      // let min = 0;
      // let max = 10000;

      // if (heightInput) {
      //   min = parseInt(heightInput.dataset.min);
      //   max = parseInt(heightInput.dataset.max);
      // }
      
      const isSurchargeProduct = document.querySelector(".input-options")?.getAttribute("data-surcharge");

      if (price < 0.001 || isNaN(price)) {
        if (isSurchargeProduct) {
          priceEls.forEach(element => {
            element.textContent = `€${originalPriceFormatted}`;
          });
        } else {
          priceEls.forEach(element => {
            element.textContent = "Vul een geldige waarde in";
          }); 
        }
        return;
      } 
      // else if (price < min) {
      //   priceEls.forEach(element => {
      //     element.textContent = `Vul een geldige waarde in`;
      //   });
      //   return;
      // } 
      // else if (price > max) {
      //   priceEls.forEach(element => {
      //     element.textContent = `Waarde is te groot`;
      //   });
      //   return;
      // }

      priceEls.forEach(element => {
        if (element.querySelector('span')) {
          element.querySelector('span').textContent = formatMoney(price * 100 * quantity, "€{{amount_with_comma_separator}}", false);
        } else {
          element.textContent = formatMoney(price * 100 * quantity, "€{{amount_with_comma_separator}}", false);
        }
      });

      const inputOptions = document.querySelector('.input-options');
      if (inputOptions) {
        inputOptions.setAttribute('data-product-price', price * quantity);
      }
    }    
    
    const addCartForm = document.querySelector(".shopify-product-form");

    addCartForm.addEventListener("submit", async function (event) {
        event.preventDefault();

        fillValues();

        let timestampInput = addCartForm.querySelector('input[name="properties[timestamp]"]');
        if (!timestampInput) {
            timestampInput = document.createElement("input");
            timestampInput.type = "hidden";
            timestampInput.name = "properties[_parent]";
            addCartForm.appendChild(timestampInput);
        }
        timestampInput.value = Date.now();
    
        const productId = '9994621321482';
        const inputOptions = document.querySelector(".input-options");
        if (!inputOptions) {
          return; 
        }
        const name = inputOptions.getAttribute("data-product-name") + `-${Date.now()}`;
        const price = parseFloat(inputOptions.getAttribute("data-product-price")); 
    
        const quantityInput = document.querySelector(".product__quantity input");
        const quantity = quantityInput ? parseInt(quantityInput.value.trim(), 10) || 1 : 1;
        let totalPrice = price / quantity;

        // if (surcharge != 0) {
        //   endPrice = surcharge;
        // }

        // console.log('surcharge: ', surcharge)
        // console.log('endPrice: ', endPrice)

        addHiddenInput(addCartForm, 'aantal', quantity);
    
        if (!productId || !price || !name || !quantity) {
            console.error("Invalid data:", { productId, price, name, quantity });
            alert("Fout: ontbrekende gegevens. Controleer of alle velden correct zijn ingevuld.");
            return;
        }

        const surchargeActive = document.querySelector(".input-options").getAttribute("data-surcharge") === "true";
        const surchargeValue = parseFloat(document.querySelector(".input-options").getAttribute("data-surcharge-price"));

        if (surchargeActive == true) {
          totalPrice = surchargeValue;
        }

        console.log('surchargeActive: ', surchargeActive)
        console.log('surchargeValue: ', surchargeValue)
        console.log('product weight: ', productWeight)
    
        if (totalPrice != 0) {
          try {
              const response = await fetch("https://product-configure.monkeydo.it/api/create-config", {
                  method: "POST",
                  headers: {
                      "Content-Type": "application/json",
                  },
                  body: JSON.stringify({
                      shop_name: 'kartent-b-v',
                      productId,
                      price: totalPrice, 
                      weight: productWeight,
                      name,
                  }),
              });
      
              if (!response.ok) {
                  const errorData = await response.text();
                  console.error("API Error Details:", errorData);
                  throw new Error(`API Error: ${response.statusText}`);
              }
      
              const data = await response.json();
              console.log("API Response:", data.id);
      
              const variantId = data.id;
      
              const addToCartResponse = await fetch("/cart/add.js", {
                  method: "POST",
                  headers: {
                      "Content-Type": "application/json",
                  },
                  body: JSON.stringify({
                      id: variantId,
                      properties: {
                        _child: timestampInput.value
                      },
                      quantity, 
                  }),
              });
      
              if (addToCartResponse.ok) {
                  console.log("Product succesvol toegevoegd aan de cart.");
              } else {
                  const cartErrorData = await addToCartResponse.text();
                  console.error("Error bij toevoegen aan cart:", cartErrorData);
              }
          } catch (error) {
              console.error("Error with API request:", error);
          }
      }
    });

  const quantityInput = document.querySelector(".js-qty__num");

  if (quantityInput) {
      quantityInput.addEventListener("keyup", function () {
        fillValues()
        quantityInput.dispatchEvent(new Event("change", { bubbles: true }));
      });
  }
});